import React from 'react';
import _ from 'lodash';

import { translateLogisticsError } from 'constants/logisticsErrorMessages';

export default function ErrorDescription({ error }) {
  if (typeof error === 'string') return <>{translateLogisticsError(error)}</>;
  if (!!error && typeof error === 'object') {
    const response: any = _.result(error, 'response', {});
    const errorData: any = _.result(response, 'data', { description: '', msg: '' });
    const status = error.status || response.status;
    const statusText = error.statusText || response.statusText || '';
    const message = error.message || errorData.message;
    const description = translateLogisticsError(errorData?.description);
    const msg = translateLogisticsError(errorData?.msg);
    return status || message || description || msg ? (
      <>
        {!!status && <div>{`(${status})${statusText}`}</div>}
        {!!message && <div>{message}</div>}
        {!!description && <div>{description}</div>}
        {!!msg && <div>{msg}</div>}
      </>
    ) : (
      <>{JSON.stringify(error || '')}</>
    );
  } else return null;
}

